import { RelativeTimeElement } from '@github/relative-time-element';
import { createComponent } from '../utils/create-component.js';
import { jsx } from 'react/jsx-runtime';

const RelativeTimeComponent = createComponent(RelativeTimeElement, 'relative-time');
const localeOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
};
function RelativeTime({
  date,
  datetime,
  children,
  noTitle,
  ...props
}) {
  var _date;
  if (datetime) date = new Date(datetime);
  return /*#__PURE__*/jsx(RelativeTimeComponent, {
    ...props,
    date: date,
    "no-title": noTitle ? '' : undefined,
    children: children || ((_date = date) === null || _date === void 0 ? void 0 : _date.toLocaleDateString('en', localeOptions)) || ''
  });
}
RelativeTime.displayName = "RelativeTime";

export { RelativeTime as default };
